
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function FrontPage() {

    const navigate = useNavigate();

    const projects = [
        {
            title: 'DynamicTTS',
            description: 'Converts text files to speech an plays them over Axis intecoms.',
            route: '/DynamicTTS',
            image: '/images/Bullhorn.png'
        },
        {
            title: 'Mustering System',
            description: 'A wireless keycard based mustering system.',
            route: '/mustering',
            image: '/images/Walkie.jpg'
        }
    ]
    return (
        <div className='front_page container-lg py-5'>
            {/*About me section*/}
            <section className='mb-5 text-center'>
                <h1 className="fw-bold">Hello, I am Tristian Loomis</h1>
                <p className="lead">
                I currently work as an IT Specialist/Programmer.<br/>
                I build create networks focused around camera systems.
                I also code projects focusing on usability and clarity.
                </p>
            </section>
            {/* Projects carousel section*/}
            <section>
                <h2 className="mb-4">Featured Projects</h2>
                <Carousel 
                interval={4500}
                pause="hover"
                touch
                >
                    {projects.map((project, index) => (
                        <Carousel.Item key={index}
                        onClick = {() => navigate(project.route)}
                        className="project-carousel-item">
                            <img
                            className="d-block w-100"
                            src={project.image}
                            alt={project.title}
                            />

                            <Carousel.Caption className="project-captian">
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>
                            </Carousel.Caption>
                        </Carousel.Item>
                    ))}
                </Carousel>
            </section>

        </div>
    );
}

export default FrontPage;